import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreparationComponent } from './00-preparation/preparation.component';
import { DeclarationComponent } from './01-declaration/declaration.component';
import { DeclarationEnfantComponent } from './02-declaration-enfant/declaration-enfant.component';
import { FinComponent } from './03-fin/fin.component';
import { CcdPageErreurTechniqueComponent } from './components/ccd-page-erreur-technique/ccd-page-erreur-technique.component';
import { AccesRefuseComponent, accesServiceGuard } from '@cnaf/cnaf-commons-acces-service-appli';
import { ConstanteUri } from './constants/constante-uri';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/preparation',
    pathMatch: 'full'
  }
 ,
  
  { path: 'preparation', component: PreparationComponent, 
     canActivate: [
      accesServiceGuard(
        'dalsimulateur', undefined, false, false, ConstanteUri.URL_REDIRECT_EXIT
      )
    ]
  }
    ,
  { path: 'declaration', component: DeclarationComponent },
  { path: 'declaration-enfant', component: DeclarationEnfantComponent },
  { path: 'fin', component: FinComponent },
  { path: 'page-erreur-technique', component: CcdPageErreurTechniqueComponent},
  { path: 'accesrefuse', component: AccesRefuseComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
